/* WELLIVU wishlist — favorite toggle lưu localStorage (id/handle/url/title). Load 1 lần trong theme.liquid (defer).
   PHẠM VI hiện tại: nút tim [data-wlv-wish] toggle + lưu + đồng bộ is-on/aria-pressed + cập nhật số đếm [data-wlv-wish-count] nếu có.
   Trang /pages/wishlist (sections/wlv-wishlist.liquid) phát event `wlv:wishlist-changed` khi tự sửa storage → nghe để tô lại tim + số đếm.
   Tạo 05/09/2026; 05/09 thêm listener wlv:wishlist-changed (GPT góp ý: không phát giả shopify:section:load). */
(function(){
  if(window.__wlvWishInit) return; window.__wlvWishInit=true;
  var KEY='wlv_wishlist';
  function hopLe(x){ /* CÙNG schema với trang wishlist: id không rỗng + (handle không-trắng hoặc url có segment /products/<gì đó>) */
    if(!(x&&typeof x==='object'&&x.id!=null&&String(x.id).trim()!=='')) return false;
    if(typeof x.handle==='string'&&x.handle.trim()!=='') return true;
    return typeof x.url==='string'&&/\/products\/[^\/?#\s]/.test(x.url);
  }
  function read(){ /* {items, err:'blocked'|'corrupt'|null} — CÙNG thuật toán với trang wishlist (2 nơi đọc khác nhau làm đếm/bỏ-tim lệch) */
    var raw=null;
    try{ raw=localStorage.getItem(KEY); }catch(e){ return {items:[], err:'blocked'}; }
    if(raw==null||raw===''){ return {items:[], err:null}; }
    var v=null;
    try{ v=JSON.parse(raw); }catch(e){ return {items:[], err:'corrupt'}; }
    if(!Array.isArray(v)) return {items:[], err:'corrupt'};
    var seen={}, out=[];
    for(var i=v.length-1;i>=0;i--){ var x=v[i];
      if(!hopLe(x)) continue;
      var k=String(x.id); if(seen[k]) continue; seen[k]=1; out.unshift(x); }
    return {items:out, err:(v.length>0&&out.length===0)?'corrupt':null};
  }
  function get(){ return read().items; }
  function set(a){ try{ localStorage.setItem(KEY, JSON.stringify(a)); return true; }catch(e){ return false; } }
  function toast(msg){ var t=document.getElementById('wlv-wtoast'); if(!t){ t=document.createElement('div'); t.id='wlv-wtoast'; t.setAttribute('role','status'); t.setAttribute('aria-live','polite'); t.style.cssText='position:fixed;left:50%;bottom:24px;transform:translateX(-50%);background:#0f3a68;color:#fff;padding:10px 16px;border-radius:999px;font:600 13px/1.2 sans-serif;z-index:99999;opacity:0;transition:opacity .25s;pointer-events:none;max-width:90vw;text-align:center'; document.body.appendChild(t); } t.textContent=''; requestAnimationFrame(function(){ t.textContent=msg; }); t.style.opacity='1'; clearTimeout(t._h); t._h=setTimeout(function(){ t.style.opacity='0'; },3000); }
  function count(){ var n=get().length; document.querySelectorAll('[data-wlv-wish-count]').forEach(function(e){ e.textContent=n; e.hidden=(n===0); }); }
  function sync(){
    var st=read();
    if(st.err==='blocked') return; /* không đọc được ≠ wishlist rỗng — GIỮ trạng thái tim/badge hiện có, đừng tắt hết (corrupt = data hỏng thật thì phản ánh như rỗng) */
    var ids=st.items.map(function(x){return ''+x.id;});
    document.querySelectorAll('[data-wlv-wish]').forEach(function(b){
      var on=ids.indexOf(b.dataset.pid)>-1, ten=b.dataset.title||'product';
      b.classList.toggle('is-on',on);
      b.setAttribute('aria-pressed', on?'true':'false');
      b.setAttribute('aria-label', on?('Remove '+ten+' from wishlist'):('Add '+ten+' to wishlist')); /* kèm tên SP cho screen reader phân biệt (GPT vòng 3) */
    });
    count();
  }
  document.addEventListener('click', function(e){
    var b=e.target.closest('[data-wlv-wish]'); if(!b) return;
    e.preventDefault(); e.stopPropagation();
    var st=read();
    if(st.err==='blocked'){ toast('Your wishlist couldn’t be updated in this browser.'); return; } /* đọc bị chặn → KHÔNG ghi đè mù (ghi vẫn có thể thành công và xoá sạch danh sách cũ) */
    /* err==='corrupt': data hỏng không đọc được — ghi danh sách MỚI từ đây là phục hồi CHỦ ĐÍCH */
    var a=st.items, k=String(b.dataset.pid), co=a.some(function(x){return String(x.id)===k;});
    if(co){ a=a.filter(function(x){ return String(x.id)!==k; }); } /* filter hết mọi bản cùng id (không splice 1 bản) */
    else {
      var it={id:b.dataset.pid, handle:(b.dataset.handle||'').trim(), title:b.dataset.title, url:b.dataset.url};
      if(!hopLe(it)){ toast('Could not save this product.'); return; } /* validate TRƯỚC khi ghi — markup thiếu data không tạo bản ghi câm */
      a.push(it);
    }
    if(set(a)){ sync(); } else { toast('Your wishlist couldn’t be saved in this browser.'); }
  });
  if(document.readyState!=='loading') sync(); else document.addEventListener('DOMContentLoaded', sync);
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('wlv:wishlist-changed', sync); /* trang wishlist báo storage đổi (xoá/×/Try again) */
  window.addEventListener('storage', function(e){ if(e.key===KEY || e.key===null) sync(); }); /* đồng bộ đa tab (key=null khi clear) */
})();
